function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M284.593 104.734C304.759 146.555 334.743 255.442 222.891 253.273C132.794 251.526 92.3499 311.97 51.8859 249.957C28.5923 214.259 30.5081 119.567 141.957 63.8512C228.898 20.388 271.288 77.1425 284.593 104.734Z",
  fill: "var(--fan-theme_clubNavigation1, var(--fan-theme_clubNavigation1-override, rgba(51,51,51,1)))",
  fillOpacity: 0.1
});
var _ref3 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0_UPAuXMFlXgECb92pyeSo5AG22Cm69LwO5dYqntb4EM",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 70,
  y: 55,
  width: 128,
  height: 182
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M88.895 84.1134C83.6334 85.6122 78.1529 82.5618 76.6541 77.3002C76.5737 77.0177 76.2827 76.8443 76.0003 76.9247L73.0254 77.7721C71.1963 78.2931 70.1359 80.1983 70.6569 82.0274L107.14 210.103C107.195 210.579 107.289 211.057 107.424 211.533L114.072 234.872C114.482 236.308 115.978 237.141 117.414 236.732L119.64 236.098C119.922 236.018 120.078 235.717 119.997 235.435C118.498 230.173 121.549 224.693 126.81 223.194C132.072 221.695 137.552 224.746 139.051 230.007C139.132 230.29 139.422 230.463 139.705 230.383L145.623 228.697C145.905 228.616 146.061 228.316 145.98 228.034C144.481 222.772 147.532 217.292 152.793 215.793C158.055 214.294 163.536 217.345 165.034 222.606C165.115 222.888 165.405 223.062 165.687 222.981L171.605 221.295C171.888 221.215 172.043 220.915 171.963 220.633C170.464 215.371 173.514 209.891 178.776 208.392C184.038 206.893 189.518 209.943 191.017 215.205C191.097 215.487 191.388 215.66 191.67 215.58L194.646 214.732C196.475 214.211 197.536 212.306 197.015 210.476L191.653 191.653C191.598 191.177 191.504 190.699 191.369 190.223L153.599 57.6323C153.19 56.1957 151.694 55.3629 150.257 55.7721L148.032 56.4059C147.75 56.4864 147.594 56.7869 147.675 57.0692C149.173 62.3308 146.123 67.8112 140.861 69.3101C135.6 70.8089 130.119 67.7585 128.621 62.4969C128.54 62.2146 128.249 62.0412 127.967 62.1216L122.049 63.8075C121.766 63.888 121.61 64.1887 121.691 64.4711C123.19 69.7327 120.139 75.2131 114.878 76.7119C109.616 78.2108 104.136 75.1604 102.637 69.8987C102.556 69.6163 102.265 69.4429 101.983 69.5234L96.0661 71.2088C95.7836 71.2893 95.6277 71.59 95.7082 71.8725C97.207 77.1341 94.1566 82.6146 88.895 84.1134Z",
  fill: "white"
}));
var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_UPAuXMFlXgECb92pyeSo5AG22Cm69LwO5dYqntb4EM)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M88.895 84.1134C83.6334 85.6122 78.1529 82.5618 76.6541 77.3002C76.5737 77.0177 76.2827 76.8443 76.0003 76.9247L73.0254 77.7721C71.1963 78.2931 70.1359 80.1983 70.6569 82.0274L107.14 210.103C107.195 210.579 107.289 211.057 107.424 211.533L114.072 234.872C114.482 236.308 115.978 237.141 117.414 236.732L119.64 236.098C119.922 236.018 120.078 235.717 119.997 235.435C118.498 230.173 121.549 224.693 126.81 223.194C132.072 221.695 137.552 224.746 139.051 230.007C139.132 230.29 139.422 230.463 139.705 230.383L145.623 228.697C145.905 228.616 146.061 228.316 145.98 228.034C144.481 222.772 147.532 217.292 152.793 215.793C158.055 214.294 163.536 217.345 165.034 222.606C165.115 222.888 165.405 223.062 165.687 222.981L171.605 221.295C171.888 221.215 172.043 220.915 171.963 220.633C170.464 215.371 173.514 209.891 178.776 208.392C184.038 206.893 189.518 209.943 191.017 215.205C191.097 215.487 191.388 215.66 191.67 215.58L194.646 214.732C196.475 214.211 197.536 212.306 197.015 210.476L191.653 191.653C191.598 191.177 191.504 190.699 191.369 190.223L153.599 57.6323C153.19 56.1957 151.694 55.3629 150.257 55.7721L148.032 56.4059C147.75 56.4864 147.594 56.7869 147.675 57.0692C149.173 62.3308 146.123 67.8112 140.861 69.3101C135.6 70.8089 130.119 67.7585 128.621 62.4969C128.54 62.2146 128.249 62.0412 127.967 62.1216L122.049 63.8075C121.766 63.888 121.61 64.1887 121.691 64.4711C123.19 69.7327 120.139 75.2131 114.878 76.7119C109.616 78.2108 104.136 75.1604 102.637 69.8987C102.556 69.6163 102.265 69.4429 101.983 69.5234L96.0661 71.2088C95.7836 71.2893 95.6277 71.59 95.7082 71.8725C97.207 77.1341 94.1566 82.6146 88.895 84.1134Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M92.895 84.1134C87.6334 85.6122 82.1529 82.5618 80.6541 77.3002C80.5737 77.0177 80.2827 76.8443 80.0003 76.9247L77.0254 77.7721C75.1963 78.2931 74.1359 80.1983 74.6569 82.0274L111.14 210.103C111.195 210.579 111.289 211.057 111.424 211.533L118.072 234.872C118.482 236.308 119.978 237.141 121.414 236.732L123.64 236.098C123.922 236.018 124.078 235.717 123.997 235.435C122.498 230.173 125.549 224.693 130.81 223.194C136.072 221.695 141.552 224.746 143.051 230.007C143.132 230.29 143.422 230.463 143.705 230.383L149.623 228.697C149.905 228.616 150.061 228.316 149.98 228.034C148.481 222.772 151.532 217.292 156.793 215.793C162.055 214.294 167.536 217.345 169.034 222.606C169.115 222.888 169.405 223.062 169.687 222.981L175.605 221.295C175.888 221.215 176.043 220.915 175.963 220.633C174.464 215.371 177.514 209.891 182.776 208.392C188.038 206.893 193.518 209.943 195.017 215.205C195.097 215.487 195.388 215.66 195.67 215.58L198.646 214.732C200.475 214.211 201.536 212.306 201.015 210.476L195.653 191.653C195.598 191.177 195.504 190.699 195.369 190.223L157.599 57.6323C157.19 56.1957 155.694 55.3629 154.257 55.7721L152.032 56.4059C151.75 56.4864 151.594 56.7869 151.675 57.0692C153.173 62.3308 150.123 67.8112 144.861 69.3101C139.6 70.8089 134.119 67.7585 132.621 62.4969C132.54 62.2146 132.249 62.0412 131.967 62.1216L126.049 63.8075C125.766 63.888 125.61 64.1887 125.691 64.4711C127.19 69.7327 124.139 75.2131 118.878 76.7119C113.616 78.2108 108.136 75.1604 106.637 69.8987C106.556 69.6163 106.265 69.4429 105.983 69.5234L100.066 71.2088C99.7836 71.2893 99.6277 71.59 99.7082 71.8725C101.207 77.1341 98.1566 82.6146 92.895 84.1134Z",
  fill: "var(--fan-theme_clubPrimaryLight, var(--fan-theme_clubPrimaryLight-override, rgba(172,110,231,1)))"
}));
var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 85.8434,
  y: 95.709,
  width: 69.503,
  height: 124.749,
  rx: 8.86687,
  transform: "rotate(-15.85 85.8434 95.709)",
  fill: "white"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M122.343 183.993L167.2 171.217",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M126.435 198.404L171.292 185.627",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M119.789 192.39L174.398 176.836",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M103.181 156.508L169.925 137.558M175.075 155.699L108.331 174.648",
  stroke: "var(--fan-theme_clubPrimaryLight, var(--fan-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
  strokeWidth: 2
});
var _ref10 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.4,
  x: 102.016,
  y: 102.28,
  width: 43.7767,
  height: 43.7767,
  rx: 21.8883,
  transform: "rotate(-15.8999 102.016 102.28)",
  fill: "var(--fan-theme_clubPrimaryLight, var(--fan-theme_clubPrimaryLight-override, rgba(172,110,231,1)))"
});
var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 97.5724,
  y: 100.034,
  width: 48.3521,
  height: 48.3521,
  rx: 24.1761,
  transform: "rotate(-15.8999 97.5724 100.034)",
  stroke: "black",
  strokeWidth: 2
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M119.521 114.043C119.123 113.499 118.636 113.041 118.088 112.694C117.54 112.347 116.941 112.118 116.326 112.021C115.711 111.924 115.092 111.959 114.504 112.127C113.915 112.294 113.37 112.588 112.898 112.994C112.425 113.4 112.036 113.91 111.752 114.493C111.468 115.076 111.295 115.722 111.242 116.393",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round"
});
var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M141.092 107.919C140.694 107.375 140.207 106.917 139.659 106.57C139.111 106.223 138.513 105.994 137.898 105.897C137.283 105.8 136.663 105.835 136.075 106.002C135.486 106.17 134.941 106.464 134.469 106.87C133.996 107.276 133.607 107.786 133.323 108.369C133.039 108.952 132.866 109.598 132.813 110.269",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round"
});
var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M123.975 129.9C122.994 128.969 122.043 127.861 121.147 126.604C120.832 126.163 121.018 125.475 121.655 125.267L136.21 120.509C136.847 120.3 137.403 120.745 137.41 121.288C137.43 122.831 137.316 124.287 137.075 125.617C136.71 127.628 136.066 129.287 135.215 130.529C134.369 131.765 133.343 132.553 132.213 132.923C131.084 133.292 129.79 133.262 128.377 132.765C126.957 132.265 125.457 131.307 123.975 129.9Z",
  fill: "white",
  stroke: "black",
  strokeWidth: 2
});
var _ref15 = /*#__PURE__*/React.createElement("mask", {
  id: "mask1_UPAuXMFlXgECb92pyeSo5AG22Cm69LwO5dYqntb4EM",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 135,
  y: 108,
  width: 148,
  height: 185
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M216.626 124.458C211.683 122.115 209.575 116.208 211.918 111.264C212.044 110.998 211.939 110.676 211.674 110.55L208.879 109.225C207.161 108.411 205.107 109.143 204.292 110.862L147.25 231.208C146.98 231.6 146.737 232.019 146.527 232.463L136.133 254.391C135.493 255.741 136.069 257.354 137.419 257.994L139.51 258.985C139.775 259.11 140.09 258.987 140.216 258.722C142.559 253.779 148.466 251.67 153.41 254.014C158.354 256.357 160.462 262.264 158.119 267.208C157.993 267.473 158.097 267.795 158.362 267.92L163.924 270.556C164.189 270.682 164.503 270.559 164.629 270.294C166.972 265.35 172.879 263.242 177.823 265.586C182.767 267.929 184.875 273.836 182.532 278.78C182.406 279.045 182.51 279.366 182.775 279.492L188.337 282.128C188.601 282.253 188.916 282.13 189.042 281.865C191.385 276.922 197.292 274.814 202.236 277.157C207.18 279.5 209.288 285.407 206.945 290.351C206.819 290.616 206.923 290.938 207.188 291.063L209.984 292.388C211.703 293.203 213.756 292.47 214.571 290.751L222.958 273.056C223.229 272.665 223.472 272.246 223.682 271.802L282.73 147.222C283.37 145.873 282.795 144.26 281.445 143.62L279.355 142.629C279.089 142.503 278.773 142.627 278.648 142.892C276.304 147.836 270.397 149.944 265.453 147.601C260.51 145.258 258.401 139.35 260.745 134.407C260.871 134.141 260.766 133.819 260.501 133.693L254.941 131.058C254.675 130.932 254.359 131.055 254.234 131.321C251.89 136.264 245.983 138.372 241.039 136.029C236.096 133.686 233.988 127.779 236.331 122.835C236.457 122.569 236.352 122.247 236.087 122.121L230.528 119.486C230.263 119.361 229.947 119.484 229.821 119.75C227.477 124.693 221.57 126.802 216.626 124.458Z",
  fill: "white"
}));
var _ref16 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask1_UPAuXMFlXgECb92pyeSo5AG22Cm69LwO5dYqntb4EM)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M216.626 124.458C211.683 122.115 209.575 116.208 211.918 111.264C212.044 110.998 211.939 110.676 211.674 110.55L208.879 109.225C207.161 108.411 205.107 109.143 204.292 110.862L147.25 231.208C146.98 231.6 146.737 232.019 146.527 232.463L136.133 254.391C135.493 255.741 136.069 257.354 137.419 257.994L139.51 258.985C139.775 259.11 140.09 258.987 140.216 258.722C142.559 253.779 148.466 251.67 153.41 254.014C158.354 256.357 160.462 262.264 158.119 267.208C157.993 267.473 158.097 267.795 158.362 267.92L163.924 270.556C164.189 270.682 164.503 270.559 164.629 270.294C166.972 265.35 172.879 263.242 177.823 265.586C182.767 267.929 184.875 273.836 182.532 278.78C182.406 279.045 182.51 279.366 182.775 279.492L188.337 282.128C188.601 282.253 188.916 282.13 189.042 281.865C191.385 276.922 197.292 274.814 202.236 277.157C207.18 279.5 209.288 285.407 206.945 290.351C206.819 290.616 206.923 290.938 207.188 291.063L209.984 292.388C211.703 293.203 213.756 292.47 214.571 290.751L222.958 273.056C223.229 272.665 223.472 272.246 223.682 271.802L282.73 147.222C283.37 145.873 282.795 144.26 281.445 143.62L279.355 142.629C279.089 142.503 278.773 142.627 278.648 142.892C276.304 147.836 270.397 149.944 265.453 147.601C260.51 145.258 258.401 139.35 260.745 134.407C260.871 134.141 260.766 133.819 260.501 133.693L254.941 131.058C254.675 130.932 254.359 131.055 254.234 131.321C251.89 136.264 245.983 138.372 241.039 136.029C236.096 133.686 233.988 127.779 236.331 122.835C236.457 122.569 236.352 122.247 236.087 122.121L230.528 119.486C230.263 119.361 229.947 119.484 229.821 119.75C227.477 124.693 221.57 126.802 216.626 124.458Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M219.626 126.458C214.683 124.115 212.575 118.208 214.918 113.264C215.044 112.998 214.939 112.676 214.674 112.55L211.879 111.225C210.161 110.411 208.107 111.143 207.292 112.862L150.25 233.208C149.98 233.6 149.737 234.019 149.527 234.463L139.133 256.391C138.493 257.741 139.069 259.354 140.419 259.994L142.51 260.985C142.775 261.11 143.09 260.987 143.216 260.722C145.559 255.779 151.466 253.67 156.41 256.014C161.354 258.357 163.462 264.264 161.119 269.208C160.993 269.473 161.097 269.795 161.362 269.92L166.924 272.556C167.189 272.682 167.503 272.559 167.629 272.294C169.972 267.35 175.879 265.242 180.823 267.586C185.767 269.929 187.875 275.836 185.532 280.78C185.406 281.045 185.51 281.366 185.775 281.492L191.337 284.128C191.601 284.253 191.916 284.13 192.042 283.865C194.385 278.922 200.292 276.814 205.236 279.157C210.18 281.5 212.288 287.407 209.945 292.351C209.819 292.616 209.923 292.938 210.188 293.063L212.984 294.388C214.703 295.203 216.756 294.47 217.571 292.751L225.958 275.056C226.229 274.665 226.472 274.246 226.682 273.802L285.73 149.222C286.37 147.873 285.795 146.26 284.445 145.62L282.355 144.629C282.089 144.503 281.773 144.627 281.648 144.892C279.304 149.836 273.397 151.944 268.453 149.601C263.51 147.258 261.401 141.35 263.745 136.407C263.871 136.141 263.766 135.819 263.501 135.693L257.941 133.058C257.675 132.932 257.359 133.055 257.234 133.321C254.89 138.264 248.983 140.372 244.039 138.029C239.096 135.686 236.988 129.779 239.331 124.835C239.457 124.569 239.352 124.247 239.087 124.121L233.528 121.486C233.263 121.361 232.947 121.484 232.821 121.75C230.477 126.693 224.57 128.802 219.626 126.458Z",
  fill: "var(--fan-theme_clubPrimaryLight, var(--fan-theme_clubPrimaryLight-override, rgba(172,110,231,1)))"
}));
var _ref17 = /*#__PURE__*/React.createElement("rect", {
  x: 208.233,
  y: 130.608,
  width: 68.7574,
  height: 123.411,
  rx: 8.86687,
  transform: "rotate(25.41 208.233 130.608)",
  fill: "white"
});
var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M177.4 220.279L219.546 240.257",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round"
});
var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M170.972 233.81L213.118 253.788",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round"
});
var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M169.943 224.907L221.251 249.228",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round"
});
var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M181.541 187.18L243.194 216.468M235.102 233.501L173.45 204.213",
  stroke: "var(--fan-theme_clubPrimaryLight, var(--fan-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
  strokeWidth: 2
});
var _ref22 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.4,
  x: 216.82,
  y: 144.915,
  width: 44.2832,
  height: 44.2832,
  rx: 22.1416,
  transform: "rotate(25.3601 216.82 144.915)",
  fill: "var(--fan-theme_clubPrimaryLight, var(--fan-theme_clubPrimaryLight-override, rgba(172,110,231,1)))"
});
var _ref23 = /*#__PURE__*/React.createElement("rect", {
  x: 214.147,
  y: 140.831,
  width: 48.3521,
  height: 48.3521,
  rx: 24.1761,
  transform: "rotate(25.3601 214.147 140.831)",
  stroke: "black",
  strokeWidth: 2
});
var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M214.247 180.951C214.177 179.601 214.25 178.143 214.465 176.615C214.541 176.077 215.149 175.707 215.755 175.995L229.586 182.565C230.192 182.853 230.288 183.558 229.92 183.956C228.871 185.089 227.787 186.066 226.696 186.865C225.047 188.072 223.438 188.832 221.965 189.147C220.501 189.46 219.214 189.326 218.14 188.816C217.067 188.306 216.149 187.393 215.467 186.06C214.781 184.72 214.353 182.992 214.247 180.951Z",
  fill: "white",
  stroke: "black",
  strokeWidth: 2
});
var _ref25 = /*#__PURE__*/React.createElement("circle", {
  cx: 216.923,
  cy: 165.049,
  r: 5,
  transform: "rotate(25.4063 216.923 165.049)",
  fill: "black"
});
var _ref26 = /*#__PURE__*/React.createElement("circle", {
  cx: 216.619,
  cy: 162.331,
  r: 2.5,
  transform: "rotate(25.4063 216.619 162.331)",
  fill: "white"
});
var _ref27 = /*#__PURE__*/React.createElement("circle", {
  cx: 238.486,
  cy: 175.005,
  r: 5,
  transform: "rotate(25.4063 238.486 175.005)",
  fill: "black"
});
var _ref28 = /*#__PURE__*/React.createElement("circle", {
  cx: 237.881,
  cy: 172.331,
  r: 2.5,
  transform: "rotate(25.4063 237.881 172.331)",
  fill: "white"
});
var _ref29 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M153 214L180 157.5",
  stroke: "black",
  strokeWidth: 4,
  strokeLinecap: "round"
});
var SvgHappyTicketsstyled = function SvgHappyTicketsstyled(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 343,
    viewBox: "0 0 343 343",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHappyTicketsstyled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/happy-tickets.styled.c755120c.svg";
export { ForwardRef as ReactComponent };